import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.business_glossary"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        var on = ref.on
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ml-1 btn-inca-secondary mr-1",
                                  attrs: { dense: "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEditTpl(
                                        _vm.update_reg,
                                        "Insert"
                                      )
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(VIcon, { attrs: { small: "" } }, [
                                _vm._v("icon-add"),
                              ]),
                              _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Insert new business term")])]
              ),
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        var on = ref.on
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ml-1 btn-inca-secondary mr-1",
                                  attrs: { dense: "", outlined: "" },
                                  on: { click: _vm.onDownloadBulk },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(VIcon, { attrs: { small: "" } }, [
                                _vm._v("icon-download"),
                              ]),
                              _vm._v(_vm._s(_vm.$t("botones.boton_download"))),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Descarga de los elementos seleccionados o todos los elementos si no hay ninguno seleccionado"
                    ),
                  ]),
                ]
              ),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ml-1 btn-inca-secondary",
                                  attrs: { outlined: "", dense: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showTree = true
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(VIcon, { attrs: { small: "" } }, [
                                _vm._v("mdi-file-tree"),
                              ]),
                              _vm._v(_vm._s(_vm.$t("botones.boton_glossary"))),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("menu.dp.business_glossary"))),
                  ]),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(VRow, { attrs: { dense: "" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("organizacion-component", {
                          attrs: {
                            custom_orgs: _vm.selectOrganization,
                            show_all: false,
                          },
                          model: {
                            value: _vm.cDomain,
                            callback: function ($$v) {
                              _vm.cDomain = $$v
                            },
                            expression: "cDomain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VTextField, {
                          attrs: {
                            label: "Text filter",
                            placeholder: "Text filter",
                            type: "text",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            },
                          },
                          model: {
                            value: _vm.text_filter,
                            callback: function ($$v) {
                              _vm.text_filter = $$v
                            },
                            expression: "text_filter",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.texts.domain,
                            items: _vm.selectBusinessDomain,
                            dense: "",
                            outlined: "",
                            disabled: _vm.showShared,
                          },
                          model: {
                            value: _vm.kdomain,
                            callback: function ($$v) {
                              _vm.kdomain = $$v
                            },
                            expression: "kdomain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.texts.subdomain,
                            dense: "",
                            outlined: "",
                            items: _vm.filterSubdomain,
                            size: "sm",
                            disabled: _vm.showShared,
                          },
                          model: {
                            value: _vm.ksubdomain,
                            callback: function ($$v) {
                              _vm.ksubdomain = $$v
                            },
                            expression: "ksubdomain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: "Filter",
                            dense: "",
                            outlined: "",
                            options: _vm.sharedOptions,
                            size: "sm",
                          },
                          on: { change: _vm.getFilteredTerms },
                          model: {
                            value: _vm.filterSelected,
                            callback: function ($$v) {
                              _vm.filterSelected = $$v
                            },
                            expression: "filterSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c("div", { class: _vm.getClassTable }, [
          _c(
            "div",
            { staticClass: "min-w-0 w-full" },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      items: _vm.filterterms,
                      headers: _vm.relationshipField,
                      "thead-class": "tglossaryhead",
                      "tbody-class": "tglossarybody",
                      responsive: "",
                      hover: "",
                      search: _vm.text_filter_,
                      busy: _vm.isLoading,
                      bordered: "",
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                      "show-select": "",
                      "item-key": "kbusiness_term",
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.domain",
                        fn: function (ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var attrs = ref.attrs
                                        var on = ref.on
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b({}, "span", attrs, false),
                                              on
                                            ),
                                            [_vm._v(_vm._s(item.domain))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getDomainDef(item.domain))),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            !item.shared ||
                            (item.shared === true && _vm.isDomainItc)
                              ? [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var attrs = ref.attrs
                                              var on = ref.on
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-modal",
                                                            rawName:
                                                              "v-b-modal.delterm-modal",
                                                            modifiers: {
                                                              "delterm-modal": true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          dense: "",
                                                          id:
                                                            "botton-view-" +
                                                            index,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.viewItem(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-view")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("View business term")])]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var attrs = ref.attrs
                                              var on = ref.on
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          dense: "",
                                                          id: "create-" + index,
                                                          disabled:
                                                            _vm.validUser,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openEditTpl(
                                                              item,
                                                              "Edit"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-edit")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Update business term"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var attrs = ref.attrs
                                              var on = ref.on
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          dense: "",
                                                          id:
                                                            "relation-" + index,
                                                          color: "purple",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openRelation(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [
                                                        _vm._v(
                                                          "mdi-link-variant"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("View Relationship")])]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var attrs = ref.attrs
                                              var on = ref.on
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-modal",
                                                            rawName:
                                                              "v-b-modal.delterm-modal",
                                                            modifiers: {
                                                              "delterm-modal": true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          dense: "",
                                                          id:
                                                            "botton-delete-" +
                                                            index,
                                                          disabled:
                                                            _vm.validUser,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.assignDelBterm(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-delete")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Delete business term"),
                                      ]),
                                    ]
                                  ),
                                ]
                              : !_vm.isDomainItc || _vm.showShared
                              ? [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        small: "",
                                        dense: "",
                                        outlined: "",
                                        rounded: "",
                                        color: "default",
                                      },
                                    },
                                    [_vm._v("SHARED")]
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "cell.business_term",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-green-600 hover:underline",
                                attrs: {
                                  to: {
                                    name: "BusinessTerm",
                                    params: {
                                      id: item.kbusiness_term,
                                      domain: item.bdomain,
                                    },
                                  },
                                },
                              },
                              [_c("b", [_vm._v(_vm._s(item.business_term))])]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.vstatus",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(_vm._s(item.status ? "Active" : "Inactive")),
                          ]
                        },
                      },
                      {
                        key: "cell(listval)",
                        fn: function (data) {
                          return _vm._l(
                            data.item.values,
                            function (item, tidx) {
                              return _c("li", { staticClass: "v-item" }, [
                                _vm._v(_vm._s(item)),
                              ])
                            }
                          )
                        },
                      },
                      {
                        key: "cell(listtag)",
                        fn: function (data) {
                          return _vm._l(
                            data.item.classification,
                            function (item, tidx) {
                              return _c("li", { staticClass: "v-item" }, [
                                _vm._v(_vm._s(item)),
                              ])
                            }
                          )
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedTerms,
                      callback: function ($$v) {
                        _vm.selectedTerms = $$v
                      },
                      expression: "selectedTerms",
                    },
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
        ]),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(VRow, { attrs: { dense: "" } }, [
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c("organizacion-component", {
                                attrs: {
                                  custom_orgs: _vm.selectOrganization,
                                  show_all: false,
                                },
                                model: {
                                  value: _vm.cDomain,
                                  callback: function ($$v) {
                                    _vm.cDomain = $$v
                                  },
                                  expression: "cDomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: "Text filter",
                                  placeholder: "Text filter",
                                  type: "text",
                                  outlined: "",
                                  dense: "",
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.text_filter,
                                  callback: function ($$v) {
                                    _vm.text_filter = $$v
                                  },
                                  expression: "text_filter",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VSelect, {
                                attrs: {
                                  label: _vm.texts.domain,
                                  items: _vm.selectBusinessDomain,
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.showShared,
                                },
                                model: {
                                  value: _vm.kdomain,
                                  callback: function ($$v) {
                                    _vm.kdomain = $$v
                                  },
                                  expression: "kdomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VSelect, {
                                attrs: {
                                  label: _vm.texts.subdomain,
                                  dense: "",
                                  outlined: "",
                                  items: _vm.filterSubdomain,
                                  size: "sm",
                                  disabled: _vm.showShared,
                                },
                                model: {
                                  value: _vm.ksubdomain,
                                  callback: function ($$v) {
                                    _vm.ksubdomain = $$v
                                  },
                                  expression: "ksubdomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VSelect, {
                                attrs: {
                                  label: "Filter",
                                  dense: "",
                                  outlined: "",
                                  items: _vm.sharedOptions,
                                  size: "sm",
                                },
                                on: { change: _vm.getFilteredTerms },
                                model: {
                                  value: _vm.filterSelected,
                                  callback: function ($$v) {
                                    _vm.filterSelected = $$v
                                  },
                                  expression: "filterSelected",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12 text-right" },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "default mr-1",
                                  attrs: { outlined: "" },
                                  on: { click: _vm.onLimpiar },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "primary",
                                  on: { click: _vm.onSearch },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.search")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.showTree && _vm.terms.length > 0
        ? _c(
            VNavigationDrawer,
            {
              attrs: { absolute: "", right: "", temporary: "" },
              model: {
                value: _vm.showTree,
                callback: function ($$v) {
                  _vm.showTree = $$v
                },
                expression: "showTree",
              },
            },
            [
              _c(
                VLazy,
                {
                  model: {
                    value: _vm.showTree,
                    callback: function ($$v) {
                      _vm.showTree = $$v
                    },
                    expression: "showTree",
                  },
                },
                [
                  _c("sidebar-tree-business-terms", {
                    attrs: { terms: _vm.terms },
                    on: {
                      onClose: function ($event) {
                        _vm.showTree = false
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ACCESS,
          attrs: {
            title:
              _vm.tplToUpdate.type == "Edit"
                ? _vm.$t("frases.edit_bterm")
                : _vm.$t("frases.new_bterm"),
            width: 1200,
            showCancelButton: false,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-business-terms-component", {
                key: _vm.key_edit,
                ref: _vm.MODAL_NAME_ACCESS + "_component",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  fDomain: _vm.cDomain,
                  terms: _vm.terms,
                  idomain: _vm.kdomain,
                  isubdomain: _vm.ksubdomain,
                },
                on: {
                  submit: _vm.onSubmitBusinessTerm,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_ACCESS].onClose()
                  },
                  "tab-change": function ($event) {
                    _vm.currentTab = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.currentTab === 2
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NAME_ACCESS + "_component"
                          ].onSubmit($event)
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-check-circle-outline"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ACCESS_VIEW,
          attrs: { title: "Ver Término de Negocio", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-business-terms-component", {
                key: _vm.key_view,
                ref: _vm.MODAL_NAME_ACCESS_VIEW + "_component",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  fDomain: _vm.cDomain,
                  terms: _vm.terms,
                  idomain: _vm.kdomain,
                  isubdomain: _vm.ksubdomain,
                  view: true,
                },
                on: {
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_ACCESS_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmation",
        attrs: { title: "Confirmación" },
        on: { onConfirm: _vm.onConfirmDeleteBusinessTerm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }